import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalButton from "../../../layout/conditional-button";
import { initialState } from "../../../layout/table/helpers";

import { send as pageInfo, loading } from "../../../actions/page";
import { search as searchFinancialAccounts } from "../../../actions/financial.accounts";
import { withNavigation } from "../../../utils/wrapper";

const toCaption = (value) => String(value || "")
  .toLowerCase()
  .split("_")
  .filter(Boolean)
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(" ");

class FinancialAccounts extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState({ order: "name", direction: "ASC", size: 25 });
    this.props.loading(true);
  }

  componentDidMount = () => {
    setTimeout(async () => {
      await this.loadData();
    }, 30);
  };

  loadData = async () => {
    this.props.loading(true);

    const { page, size, order, direction, search } = this.state;
    const result = await this.props.searchFinancialAccounts({ search, page, size, order, direction });
    const count = Number(result?.count ?? 0);
    const pages = size > 0 ? Math.ceil(count / Number(size)) : 0;

    this.setState({
      data: result?.items || [],
      pages,
    });

    await this.props.pageInfo({ title: "Financial Accounts", breadcrumb: "Financial Accounts" });
    this.props.loading(false);
  };

  get headers() {
    return [
      {
        header: "Name",
        sortable: true,
        source: "name",
        className: "text-muted text-small text-uppercase w-30",
        onFormat: this.onNameFormat,
      },
      {
        header: "Type",
        sortable: true,
        source: "accountType",
        className: "text-muted text-small text-uppercase w-15",
        onFormat: toCaption,
      },
      {
        header: "Institution",
        sortable: true,
        source: "financialInstitution",
        className: "text-muted text-small text-uppercase w-20",
      },
      {
        header: "Last Four",
        sortable: true,
        source: "lastFour",
        className: "text-muted text-small text-uppercase w-10",
      },
      {
        header: "Trust",
        sortable: true,
        source: "isTrustAccount",
        className: "text-muted text-small text-uppercase w-10",
        onFormat: this.onBooleanFormat,
      },
      {
        header: "Active",
        sortable: true,
        source: "isActive",
        className: "text-muted text-small text-uppercase w-10",
        onFormat: this.onBooleanFormat,
      },
    ];
  }

  onBooleanFormat = (value) => value ? "Yes" : "No";

  onNameFormat = (value, row) => {
    const text = value || row?.uuid || "";
    return `<a href="/dashboard/accounting/financial-accounts/${row.uuid}">${text}</a>`;
  };

  onNewClick = () => {
    this.props.navigate("add");
  };

  onSearch = async (search) => {
    this.setState({ search: search ?? "", page: 0 }, this.loadData);
  };

  onSize = async (size) => {
    this.setState({ size: Number(size), page: 0 }, this.loadData);
  };

  onPageChange = async (page) => {
    this.setState({ page: Number(page) }, this.loadData);
  };

  onColumnClick = async (header) => {
    if (!header?.sortable) return;

    const order = header.source;
    const direction = this.state.order === order && this.state.direction === "ASC" ? "DESC" : "ASC";

    this.setState({ order, direction, page: 0 }, this.loadData);
  };

  render() {
    return (
      <>
        <Col md="8" className="float-right text-end">
          <ConditionalButton
            enabledVariant="outline-primary"
            tooltip="Create new financial account"
            display
            enabled={true}
            onEnabledClick={this.onNewClick}
            icon="flash"
          >
            New
          </ConditionalButton>
        </Col>

        <Col xs="12">
          <Table
            headers={this.headers}
            page={this.state.data}
            size={this.state.size}
            index={this.state.page}
            pages={this.state.pages}
            onColumnClick={this.onColumnClick}
            onPageChange={this.onPageChange}
            onSearch={this.onSearch}
            onSize={this.onSize}
            searchable={true}
            sizable={true}
          />
        </Col>
      </>
    );
  }
}

FinancialAccounts.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default withNavigation(
  connect(mapStateToProps, { searchFinancialAccounts, loading, pageInfo })(FinancialAccounts)
);
